<template>
    <el-card class="main-card">
      <template #header>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">小程序商城</el-breadcrumb-item>
          <el-breadcrumb-item>商品类别管理</el-breadcrumb-item>
        </el-breadcrumb>
      </template>
      <div class="toolbar">
        <el-button type="primary" icon="plus" @click="rootDialog()">
          新增
        </el-button>
        <el-button 
          type="primary" 
          icon="Edit" 
          @click="edit(selectedRow)">
          编辑
        </el-button>
        <el-button 
          type="danger" 
          icon="Delete" 
          @click="del(selectedRow)">
          删除
        </el-button>
        <el-button type="primary" plain icon="fold" @click="expandAll">
          展开类别
        </el-button>
        <el-button type="primary" plain icon="Expand" @click="collapseAll">
          折叠类别
        </el-button>
      </div>
  
      <el-table
        ref="categoryTable"
        class="table"
        :data="categoryData"
        row-key="id"
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren1' }"
        :default-expand-all="false"
        highlight-current-row
        @current-change="handleCurrentChange"
        size="small"
      >
        <el-table-column prop="name" label="类别名称"  width="180"></el-table-column>
        <el-table-column prop="attributeValue" label="排序号" align="center" width="80"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="80">
          <template #default="scope">
            <el-button @click="addDialog(scope.row)" type="primary" link size="small">
              新增
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  
    <el-dialog :title="!forms.id ? '新增类目' : '类别维护'" width="600px" destroy-on-close v-model="formDialogVisible" @close="close">
      <el-form :model="forms" :rules="rules" ref="forms" :label-width="formLabelWidth">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="上级类别">
              <el-select
                v-model="forms.parentID"
                filterable
                allow-create
                clearable
                placeholder="请选择或输入上级类别"
                :disabled="forms.parentID && forms.parentID.trim()"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <template v-if="!forms.id">
                <div style="color: #f56c6c; font-size: 12px; margin-top: 4px;">*若不填则视为创建一级类目</div>
              </template>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="类别名称"  prop="categoryName">
              <el-input v-model="forms.categoryName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item label="排序号">
              <el-input-number v-model="forms.sortCode" :min="1" :max="9999999" label="排序号"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="formDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </template>
  <script>
  import { fetchShopMenus,fetchShopMenuDetail, submitShopMenu, delShopMenu } from "@/api/shop";
  export default {
    name: "ShopCategoryPage",
    components: {},
    data() {
      return {
        categoryData: [],
        categorySelect: [],
        currRow: null,
        selectedRow: null, // 当前选中的行
        formDialogVisible: false,
        forms: {},
        formLabelWidth: "90px",
        rules: {
          categoryName: [{ required: true, message: "请输入类别名称", trigger: "blur" }],
        },
        categoryOptions: [],
      };
    },
    mounted() {
      this.getCategories();
    },
    methods: {
      editDialog(id) {
        this.forms = {};
        fetchShopMenuDetail(id).then((res) => {
          this.forms = res.data;
          this.formDialogVisible = true;
        });
      },
      addDialog(row) {
        this.formDialogVisible = true;
        this.forms = { parentID: row.id };
      },
      rootDialog() {
        this.forms = {};
        this.formDialogVisible = true;
      },
      close() {
        this.$refs.forms.resetFields();
      },
      currHandler(row) {
        this.currRow = row;
      },
      // 处理行选中事件
      handleCurrentChange(currentRow) {
        this.selectedRow = currentRow;
      },
      // 编辑按钮点击事件
      edit(row) {
        if (!row) {
          this.$message({
            type: 'warning',
            message: '请先选择要编辑的类别'
          });
          return;
        }
        this.editDialog(row.id);
      },
      // 删除按钮点击事件
      del(row) {
        if (!row) {
          this.$message({
            type: 'warning',
            message: '请先选择要删除的类别'
          });
          return;
        }
        this.deleHandler(row.id);
      },
      deleHandler(id) {
        let that = this;
        this.$confirm("此操作将删除本页选择数据, 是否继续?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
          .then(() => {
            delShopMenu(id).then((res) => {
              if (res.code === 200) {
                that.$message({
                  type: "success",
                  message: "删除成功",
                });
                that.getCategories();
              }
            });
          })
          .catch(() => {
            that.$message({ type: "info", message: "删除失败", });
          });
      },
      getCategories() {
        var that = this;
        fetchShopMenus().then((res) => {
          that.categoryData = JSON.parse(JSON.stringify(res)); 
          that.categorySelect = that.loopTreeData(res);
          that.categoryOptions = that.flattenTree(res);
        });
      },
      loopTreeData(data) {
        for (let i = 0; i < data.length; i++) {
          data[i].label = data[i].name;
          data[i].value = data[i].id;
          if (data[i].children && data[i].children.length > 0) {
            data[i].children = this.loopTreeData(data[i].children);
          }
        }
        return data;
      },
      flattenTree(data) {
        const options = [];
        const flatten = (node) => {
          if (node.children && node.children.length > 0) {
            node.children.forEach(child => {
              options.push({
                value: child.id,
                label: child.name,
                parentId: node.id
              });
              flatten(child);
            });
          }
        };
        data.forEach(node => {
          options.push({
            value: node.id,
            label: node.name,
            parentId: node.parentId
          });
          flatten(node);
        });
        return options;
      },
      submit() {
        let that = this;
  
        this.$refs.forms.validate((valid) => {
          if (!valid) return;
  
          // 新增或编辑时如果parentID没值
          if (!this.forms.parentID || !this.forms.parentID.trim()) {
            this.forms.parentID = '';
          }
  
          submitShopMenu(this.forms).then((res) => {
            if (res.code === 200) {
              that.$message({
                type: "success",
                message: res.content,
              });
              that.formDialogVisible = false;
              that.getCategories();
            }
          });
        });
      },
      handleStatusChange(row) {
        const updateData = {
          id: row.id,
          checkState: row.checkState
        };
        this.forms = {};
        fetchShopMenuDetail(updateData.id).then(res => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "状态更新成功"
            });
          } else {
            // 如果更新失败，回滚状态
            updateData.checkState = updateData.checkState === 1 ? 0 : 1;
            this.$message({
              type: "error",
              message: "状态更新失败"
            });
          }
        }).catch(() => {
          // 发生错误时，回滚状态
          updateData.checkState = updateData.checkState === 1 ? 0 : 1;
          this.$message({
            type: "error",
            message: "状态更新失败"
          });
        });
      },
      expandAll() {
        const expand = (rows) => {
          rows.forEach(row => {
            this.$refs.categoryTable.toggleRowExpansion(row, true);
            if (row.children && row.children.length > 0) {
              expand(row.children);
            }
          });
        };
        expand(this.categoryData);
      },
      collapseAll() {
        const collapse = (rows) => {
          rows.forEach(row => {
            this.$refs.categoryTable.toggleRowExpansion(row, false);
            if (row.children && row.children.length > 0) {
              collapse(row.children);
            }
          });
        };
        collapse(this.categoryData);
      },
    },
  };
  </script>